(() => {
	angular
		.module('main')
		.controller('QuestionnairyController', QuestionnairyController);

	QuestionnairyController.$inject = [
		'$scope',
		'$rootScope',
		'$http',
		'messageService',
		'validationService',
		'settingsService'
	];

	function QuestionnairyController(
		$scope,
		$rootScope,
		$http,
		messageService,
		validationService,
		settingsService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.isSaveNewSpinnningWheelActive = false;
			$scope.isDeleteSpinnningWheelActive = false;
			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage
					? $rootScope.paginationPerPage
					: 25,
				pageOrder: {
					predicate: 'name',
					reverse: false
				},
				search: null
			};

			// feature toggle

			settingsService.timeFormatSettings.subscribe(data => {
				if (data.questionnaireTemplatesVersion === 'V2') {
					$scope.isNewQuestionnaireAvailable = true;
				}
				if (data.questionnaireTemplatesVersion === 'V1') {
					$scope.isNewQuestionnaireAvailable = false;
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				}
			});
		});

		$scope.newQuestionnaire = {
			questions: [
				{
					questionText: '',
					index: 1
				}
			],
			name: ''
		};
		$scope.bEdit = false;
		$scope.bDuplicate = false;
		$scope.bAdd = false;

		$scope.changeAllIndexes = function() {
			$scope.newQuestionnaire.questions.forEach((item, i) => {
				item.index = i + 1;
			});
		};

		$scope.getQuestionnaireById = function(id) {
			delete $scope.newQuestionnaire;
			$http.get(`/protected/rest/questionnaires/get?id=${id}`).then(result => {
				if (result) {
					if (result.data) {
						$scope.newQuestionnaire = result.data;
						$('#newQuestionnaires')
							.modal('show')
							.on('shown.bs.modal', function() {
								const input = $(this).find('input');

								validationService.isModalClosePrevented(input);
							});
						if ($scope.bDuplicate) $scope.newQuestionnaire.id = '';
					}
				}
			});
		};

		$scope.duplicate = function(id) {
			$scope.bEdit = false;
			$scope.bAdd = false;
			$scope.bDuplicate = true;
			$scope.getQuestionnaireById(id);
			// $scope.newQuestionnaire.id = '';
		};

		$scope.edit = function(id) {
			$scope.bDuplicate = false;
			$scope.bAdd = false;
			$scope.bEdit = true;
			$scope.getQuestionnaireById(id);
		};

		$scope.deleteQuestionnaire = function(id, name) {
			$scope.deleteQuestionnaireName = name;
			$scope.newQuestionnaire = { id };
			$('#deleteModal').modal('show');
		};

		$scope.hideModal = function() {
			delete $scope.newQuestionnaire;
			$scope.bEdit = false;
			$scope.bDuplicate = false;
			$scope.bAdd = false;
			$('#newQuestionnaires').modal('hide');
		};

		$scope.deleteRequest = function(id) {
			$scope.button_disabled = true;
			$scope.isDeleteSpinnningWheelActive = true;
			$http({
				method: 'POST',
				url: `/protected/rest/questionnaires/delete?id=${id}`
			})
				.then(result => {
					successDeleteRequest(result.data);
				})
				.catch(result => errorDeleteRequest(result.data))
				.finally(() => {
					$scope.isDeleteSpinnningWheelActive = false;
					$scope.button_disabled = false;
				});
		};

		function successDeleteRequest(data) {
			if (data.errorMessage) {
				toastr.error(data.errorMessage, 'Error');
			} else {
				messageService.showToaster(
					's_0',
					'questionnaires',
					$scope.deleteQuestionnaireName
				);
				getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				$('#deleteModal').modal('hide');
			}
		}

		function errorDeleteRequest(data) {
			const errorMessage = data.errorMessage;
			if (
				errorMessage &&
				errorMessage.includes('is attached to workflow template')
			) {
				messageService.showToaster('e_0', 'questions');
			} else {
				messageService.showToaster('e_0', 'general');
			}
		}

		$scope.remove = function(index) {
			if ($scope.newQuestionnaire.questions.length != 1) {
				// $scope.newQuestionnaire.questions.splice(index, 1);
				if (!$scope.deleteQuestions) {
					$scope.deleteQuestions = [];
				}
				if ($scope.newQuestionnaire.questions[index].id) {
					$scope.deleteQuestions.push(
						$scope.newQuestionnaire.questions[index].id
					);
				}
				$scope.newQuestionnaire.questions[index];
				$scope.newQuestionnaire.questions.splice(index, 1);
				$scope.changeAllIndexes();
			}
		};

		$scope.add = function() {
			$scope.newQuestionnaire.questions.push({
				questionText: '',
				index: 1
			});
			$scope.newQuestionnaire.questions[
				$scope.newQuestionnaire.questions.length - 1
			].index =
				$scope.newQuestionnaire.questions.length;

			$scope.$watch('newQuestionnaire.questions', () => {
				const input = $('#newQuestionnaires').find('input');

				validationService.isModalClosePrevented(input);
			});
		};
		$scope.showOptIn = function(value) {
			$scope.newQuestionnaire.showOptInConsentStatement = value;
		};

		$scope.showAddNew = function() {
			delete $scope.newQuestionnaire;
			$scope.newQuestionnaire = {
				questions: [
					{
						questionText: '',
						index: 1
					}
				],
				name: '',
				showOptInConsentStatement: ''
			};
			$scope.bEdit = false;
			$scope.bDuplicate = false;
			$scope.bAdd = true;
			$('#newQuestionnaires')
				.modal('show')
				.on('shown.bs.modal', function() {
					const input = $(this).find('input');

					validationService.isModalClosePrevented(input);
				});
		};

		$scope.save = function() {
			$scope.isSaveNewSpinnningWheelActive = true;
			if (validationService.isStringEmpty($scope.newQuestionnaire.name)) {
				messageService.showToaster('e_3', 'general', 'Name');
				$scope.isSaveNewSpinnningWheelActive = false;
				return;
			}
			if (
				$scope.newQuestionnaire.showOptInConsentStatement &&
				validationService.isStringEmpty(
					$scope.newQuestionnaire.optInConsentStatement
				)
			) {
				messageService.showToaster('e_3', 'general', 'Opt-in consent');
				$scope.isSaveNewSpinnningWheelActive = false;
				return;
			}

			if ($scope.deleteQuestions) {
				$http({
					method: 'POST',
					url: '/protected/rest/questionnaires/questions/delete',
					data: $scope.deleteQuestions
				}).then(() => {});
			}

			$http({
				method: 'POST',
				url: '/protected/rest/questionnaires/save',
				data: $scope.newQuestionnaire
			}).then(result => {
				if (result.data.errorMessage) {
					toastr.error(result.data.errorMessage, 'Error');
				} else {
					if ($scope.newQuestionnaire.id) {
						messageService.showToaster(
							's_1',
							'questionnaires',
							$scope.newQuestionnaire.name
						);
					} else {
						messageService.showToaster(
							's_2',
							'questionnaires',
							$scope.newQuestionnaire.name
						);
					}
					$scope.hideModal();
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				}
				$scope.isSaveNewSpinnningWheelActive = false;
			});
		};

		$scope.breadcrumbs = [
			{ link: '/', title: 'Dashboard' },
			{ link: '/settings', title: 'Settings' },
			{ link: null, title: 'Questionnaire Templates' }
		];

		function getResultsPage(pageNumber, perPage, predicate, reverse) {
			let changed = false;
			if (
				typeof predicate !== 'undefined' &&
				predicate != null &&
				typeof reverse !== 'undefined' &&
				reverse != null
			) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (typeof perPage !== 'undefined' && perPage != null) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (typeof pageNumber !== 'undefined' && pageNumber != null) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if (
				$scope.pageRequest &&
				$scope.totalItems != 0 &&
				$scope.totalItems <
					($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1
			) {
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				$http
					.get(
						`/protected/rest/questionnaires?perPage=${
							$scope.pageRequest.perPage
						}&page=${$scope.pageRequest.page}&predicate=${
							$scope.pageRequest.pageOrder.predicate
						}&reverse=${$scope.pageRequest.pageOrder.reverse}`
					)
					.then(result => {
						if (result.data && result.data.pageRequest) {
							$scope.pageRequest = result.data.pageRequest;
						}
						$scope.gdprEnabled = result.data.gdprEnabled;
						$scope.pageNumbers = [];
						$scope.totalItems = result.data.total;
						let pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
						pagesCount = Math.ceil(pagesCount);
						for (let i = 1; i <= pagesCount; i++) {
							$scope.pageNumbers[i - 1] = i;
						}
						$scope.questionnaires = result.data.results;
					});
			}
		}

		$scope.order = function(predicate) {
			$scope.pageRequest.pageOrder.reverse =
				$scope.pageRequest.pageOrder.predicate === predicate
					? !$scope.pageRequest.pageOrder.reverse
					: false;
			getResultsPage(
				null,
				null,
				predicate,
				$scope.pageRequest.pageOrder.reverse
			);
		};

		$scope.getCurrentPage = function() {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function(newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function(newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};
		$scope.jumpBack = function(disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};
		$scope.jumpAhead = function(disabled) {
			if (!disabled) {
				if (
					$scope.totalItems >=
					$scope.pageRequest.page * $scope.pageRequest.perPage + 1
				) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		$scope.disableDragDrop = function() {
			return true;
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/questionnairyController.js